/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Code_InvalidInputs */

const en_us2_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code has 8 letters and digits.`)
};

const pt_br2_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código tem 8 letras e números.`)
};

const es_419_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código tiene 8 letras y números.`)
};

const pt_pt2_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código tem 8 letras e algarismos.`)
};

const fr_fr2_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le code compte 8 lettres et chiffres.`)
};

const de_de2_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Code hat 8 Buchstaben und Ziffern.`)
};

const it_it2_clubs_code_invalid = /** @type {(inputs: Clubs_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il codice ha 8 lettere e cifre.`)
};

/**
* | output |
* | --- |
* | "The code has 8 letters and digits." |
*
* @param {Clubs_Code_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_code_invalid = /** @type {((inputs?: Clubs_Code_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Code_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_code_invalid(inputs)
	if (locale === "es-419") return es_419_clubs_code_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_code_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_code_invalid(inputs)
	if (locale === "de-DE") return de_de2_clubs_code_invalid(inputs)
	if (locale === "it-IT") return it_it2_clubs_code_invalid(inputs)
	return en_us2_clubs_code_invalid(inputs)
});
export { clubs_code_invalid as "clubs.code_invalid" }